import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/recommendUser/home/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recommendUser/home',
    exact: true,
    meta: {
      title: '推荐用户赚现金'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendUser/historyRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendUser/historyRecord',
    meta: {
      title: '历史记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendUser/activityRule/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendUser/activityRule',
    meta: {
      title: '活动规则'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendUser/userRecommendRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendUser/userRecommendRecord',
    meta: {
      title: '推荐记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendUser/userRewardRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendUser/userRewardRecord',
    meta: {
      title: '奖励记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendUser/activityGuide/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendUser/activityGuide',
    meta: {
      title: '邀请攻略'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendUser/recommendDetail/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendUser/recommendDetail',
    meta: {
      title: '推荐详情'
    }
  }
]
